import React from "react";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardLink
} from "reactstrap";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <main className="container">
      <Card className="mt-3 mb-3">
        <CardBody>
          <CardTitle>Sorry, but we can't find that page!</CardTitle>
          <CardSubtitle>And we looked everywhere</CardSubtitle>
          <CardImg
            className="mt-2 mb-2"
            top
            width="100%"
            src="http://grfx.cstv.com/schools/tenn/graphics/15-redesign/facilities-home.jpg"
          />
          <CardText>
            Meanwhile, enjoy this beautiful image of Neyland Stadium. Try
            clicking below to go back home, or navigating through the menu above
            to find our various request forms. If you believe you've found this
            page in error, please visit the "Help" page and email us.
          </CardText>
          <CardLink tag={Link} to="/">
            Home
          </CardLink>
        </CardBody>
      </Card>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/NotFound/NotFound.js